import type { IProgramInteractionId } from '@app/domain/program/program.interface'
import type { AppAction } from '@app/state'

export enum RequestStatusId {
  Unsubmitted = 'unsubmitted',
  Error = 'error',
  Success = 'success',
}

export interface State {
  createProgramErrorMessage: string
  createProgramModalIsOpen: boolean
  createProgramStatus: RequestStatusId
  currentProgramInteraction: IProgramInteractionId
}

export const initialState: State = {
  createProgramErrorMessage: '',
  createProgramModalIsOpen: false,
  createProgramStatus: RequestStatusId.Unsubmitted,
  currentProgramInteraction: undefined,
}

export enum ActionType {
  CreateProgram = 'PROGRAM/CREATE_PROGRAM',
  CreateProgramSucceeded = 'PROGRAM/CREATE_PROGRAM_SUCCEEDED',
  CreateProgramFailed = 'PROGRAM/CREATE_PROGRAM_FAILED',
  CreateProgramModalOpened = 'PROGRAM/CREATE_PROGRAM_MODAL_OPENED',
  CreateProgramModalClosed = 'PROGRAM/CREATE_PROGRAM_MODAL_CLOSED',
  ProgramEditStarted = 'PROGRAM/PROGRAM_EDIT_STARTED',
  ProgramEditCompleted = 'PROGRAM/PROGRAM_EDIT_COMPLETED',
}

export type Action =
  | { type: ActionType.CreateProgram; name: string }
  | { type: ActionType.CreateProgramSucceeded }
  | { type: ActionType.CreateProgramFailed; errorMessage: string }
  | { type: ActionType.CreateProgramModalOpened }
  | { type: ActionType.CreateProgramModalClosed }
  | { type: ActionType.ProgramEditStarted }
  | { type: ActionType.ProgramEditCompleted }

export const actions = {
  createProgram(name: string) {
    return { type: ActionType.CreateProgram, name }
  },
  createProgramSucceeded() {
    return { type: ActionType.CreateProgramSucceeded }
  },
  createProgramFailed(errorMessage: string) {
    return { type: ActionType.CreateProgramFailed, errorMessage }
  },
  createProgramModalClosed() {
    return { type: ActionType.CreateProgramModalClosed }
  },
  createProgramModalOpened() {
    return { type: ActionType.CreateProgramModalOpened }
  },
  programEditStarted() {
    return { type: ActionType.ProgramEditStarted }
  },
  programEditCompleted() {
    return { type: ActionType.ProgramEditCompleted }
  },
}

export function reducer(state: State = initialState, action: AppAction): State {
  switch (action.type) {
    case ActionType.CreateProgramModalClosed:
      return {
        ...state,
        createProgramStatus: RequestStatusId.Unsubmitted,
        createProgramErrorMessage: '',
        createProgramModalIsOpen: false,
      }

    case ActionType.CreateProgramModalOpened:
      return {
        ...state,
        createProgramStatus: RequestStatusId.Unsubmitted,
        createProgramErrorMessage: '',
        createProgramModalIsOpen: true,
      }

    case ActionType.CreateProgramSucceeded:
      return {
        ...state,
        createProgramStatus: RequestStatusId.Unsubmitted,
        createProgramErrorMessage: '',
        createProgramModalIsOpen: false,
      }

    case ActionType.CreateProgramFailed:
      return {
        ...state,
        createProgramStatus: RequestStatusId.Unsubmitted,
        createProgramErrorMessage: action.errorMessage,
      }

    default:
      return state
  }
}
